import React from 'react'
import { Grid } from '@material-ui/core'
import { Form, FormSpy } from 'react-final-form'
import ResearchDetail from '../../../../shareUI/ResearchDetail/researchDetail'
import UploadDoc from '../../../../shareUI/uploadDoc/uploadDoc'
import PageAction from '../../pageAction'
import Dialog from '../../../../../../control/dialog/dialog'
import useManageProjectStore from '../../../../../../stores/manageProject/useManageProjectStore'
import arrayMutators from 'final-form-arrays'
import { GetProjectResultType } from '../../../../../../services/web/types/responseWebServiceTypes'
import useCloseProjectByAdmin from './useCloseProjectByAdmin'
import useCheckPermission from '../../../../../../utilities/checkPermission'
import ResearcherDetail from '../../../../shareUI/researcherDetail/researcherDetail'
import UploadAdditionalDoc from '../../../../shareUI/uploadAdditionalDoc/UploadAdditionalDoc'

export type CloseProjectByAdminViewType = CloseProjectByAdminType & ReturnType<typeof useCloseProjectByAdmin>
const CloseProjectByAdminView = (props: CloseProjectByAdminViewType) => {
    const {
        formRef,
        onRefDialog,
        configDialog,
        initialValues,
        projectData,
        initialUploadFile,
        isViewMode,
        checkUseUploadEdit,
        onDirtyChange,
        onSubmitForm,
        onClickBackToSearch,
    } = props
    const manageProjectStore = useManageProjectStore()
    const { documentTopic } = manageProjectStore
    const checkPermission = useCheckPermission()
    const isResearcher = checkPermission.isUserResearcher()
    const canUpdateDocument = checkPermission.checkCanUpdateDocument(projectData, checkPermission.isUserAdmin())

    return (
        <Form
            onSubmit={onSubmitForm}
            initialValues={{ ...initialValues, uploadFile: initialUploadFile }}
            mutators={{
                ...arrayMutators,
            }}
            keepDirtyOnReinitialize={true}
        >
            {(props) => {
                formRef.current = props
                return (
                    <React.Fragment>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <ResearchDetail dataSource={projectData} />
                            </Grid>
                            <Grid item xs={12}>
                                <ResearcherDetail dataSource={projectData} />
                            </Grid>
                            {!isResearcher && (
                                <Grid item xs={12}>
                                    <UploadDoc
                                        initialData={initialUploadFile}
                                        documentTitleList={documentTopic}
                                        latestDocument={projectData?.latestDocument}
                                        isViewMode={isViewMode && !canUpdateDocument}
                                        isUseUploadfileEdit={checkUseUploadEdit()}
                                        required={false}
                                    />

                                    <Grid item xs={12}>
                                        <UploadAdditionalDoc isViewMode={isViewMode && !canUpdateDocument} />
                                    </Grid>
                                </Grid>
                            )}

                            {!isViewMode || canUpdateDocument ? (
                                <Grid item xs={12}>
                                    <PageAction
                                        onClickSaveDraft={() => {
                                            props.form.change('submitType', 'draft')
                                            props.handleSubmit()
                                        }}
                                        onClickSave={() => {
                                            props.form.change('submitType', 'save')
                                            props.handleSubmit()
                                        }}
                                        onClickClose={onClickBackToSearch}
                                    />
                                </Grid>
                            ) : null}
                        </Grid>
                        <FormSpy subscription={{ dirty: true }} onChange={onDirtyChange} />
                        <Dialog onRef={onRefDialog} {...configDialog} />
                    </React.Fragment>
                )
            }}
        </Form>
    )
}
export type CloseProjectByAdminType = {
    projectData?: GetProjectResultType
    onSaveComplete?: (status: number, isDraft: boolean) => void
}
const CloseProjectByAdmin = (props: CloseProjectByAdminType) => {
    const closeProjectByAdminModel = useCloseProjectByAdmin(props)
    return <CloseProjectByAdminView {...props} {...closeProjectByAdminModel} />
}
export default CloseProjectByAdmin
